var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1538 9.6585V12.4877C16.1538 12.8629 16.2997 13.2227 16.5594 13.488C16.8191 13.7533 17.1712 13.9024 17.5385 13.9024H18.2308M18.2308 13.9024C18.9652 13.9024 19.6696 13.6043 20.1889 13.0737C20.7082 12.5431 21 11.8235 21 11.0731V6.82925C21 6.45407 20.8541 6.09425 20.5945 5.82896C20.3348 5.56367 19.9826 5.41462 19.6154 5.41462H17.5385C17.1003 5.41419 16.6684 5.30753 16.2785 5.10341C14.9565 4.39856 13.491 4.02061 12 4C10.4996 4.01618 9.02414 4.39425 7.69385 5.10341C7.31101 5.29995 6.88991 5.40629 6.46154 5.41462H4.38462C4.01739 5.41462 3.66521 5.56367 3.40554 5.82896C3.14588 6.09425 3 6.45407 3 6.82925V11.0731C3 11.8235 3.29176 12.5431 3.81109 13.0737C4.33042 13.6043 5.03479 13.9024 5.76923 13.9024M18.2308 13.9024L17.8015 16.1233C17.5375 17.4972 16.8146 18.7346 15.7564 19.6241C14.6982 20.5137 13.3704 21 12 21C10.6296 21 9.30185 20.5137 8.24362 19.6241C7.1854 18.7346 6.46248 17.4972 6.19846 16.1233L5.76923 13.9024M5.76923 13.9024H6.46154C6.82876 13.9024 7.18094 13.7533 7.44061 13.488C7.70028 13.2227 7.84615 12.8629 7.84615 12.4877V9.6585M11.3077 16.7316H12.6923",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogs);
export default __webpack_public_path__ + "static/media/dogs.f5c31548265e66a4d2df34763d57e18d.svg";
export { ForwardRef as ReactComponent };